export default class HeaderFixed {
  constructor () {
    this.headers = document.querySelectorAll("[data-is-header-scroll]")
    this.scrollLevelMax = 90
    this.checkScrollLevel()
    this.bindEvents()
  }

  checkScrollLevel () {
    const isFixed = window.scrollY > this.scrollLevelMax
    this.headers.forEach((header) => {
      header.classList.toggle("header--fixed", isFixed)
    })
  }

  bindEvents () {
    window.addEventListener("scroll", () => this.checkScrollLevel(), { passive: true })
  }
}
